import { BaseTour } from "@src/widgets/onboarding/classes/BaseTour"
import { ProjectsStep } from "@src/widgets/onboarding/classes/tours/ApiIntegrationTour/steps/ProjectsStep"
import { SettingsApiKeysStep } from "@src/widgets/onboarding/classes/tours/ApiIntegrationTour/steps/SettingsApiKeysStep"
import { SettingsCallBackPayout } from "@src/widgets/onboarding/classes/tours/ApiIntegrationTour/steps/SettingsCallBackPayout"
import { ONBOARDING_TOURS } from "@src/widgets/onboarding/types"

export class ApiIntegrationTour extends BaseTour {
  name = ONBOARDING_TOURS.API_INTEGRATION

  steps = [
    new ProjectsStep(),
    new SettingsApiKeysStep(),
    new SettingsCallBackPayout(),
  ]
}
